module.exports = __webpack_public_path__ + "img/cave165.0d539f20.jpg";